import React, { Key, useEffect, useMemo, useState } from "react";
import { Button, Form, Row, Tooltip } from "antd";
import { useHistory } from "react-router";
import versionsTableUtils from "../../../../lib/utils/versionsTableUtils";
import ToggleableVersionsTable from "../../../../components/ToggleableVersionsTable/ToggleableVersionsTable";
import { ReactComponent as DotsIcon } from "../../../../img/3dots.svg";
import { TableColumn } from "../../../../lib/interfaces";
import { useAppDispatch, useAppSelector } from "../../../..";
import { checkIsLoading } from "../../../../lib/utils";
import { hasAccess } from "../../../../components/RolesModule/hasAccess";
import HistoryAndPropertyModal from "../../../../components/HistoryAndPropertyModal/HistoryAndPropertyModal";
import { useTypesCharacteristicsContext } from "../../context/TypesCharacteristicsContext/TypesCharacteristicsContext";
import "./TypesCharacteristicsListTable.less";

interface TableData {
  key?: Key;
  id?: number;
  name?: string;
  dataTypeId?: number;
  alias?: string;
  actions?: string;
  buttons?: string;
}

export const TypesCharacteristicsListTable = () => {
  const history = useHistory();

  const dispatch = useAppDispatch();

  const { handleTypesCharacteristicsListSearch } = useTypesCharacteristicsContext();

  const {
    typesCharacteristicsTypesDataDic,
    typesCharacteristics,
    typesCharacteristicsLoading,
    typesCharacteristicsPagination,
    typesCharacteristicsTotalElements,
  } = useAppSelector((state) => state.typesCharacteristics);

  const [form] = Form.useForm();

  

  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [objectId, setObjectId] = useState<number | null>(null);

  const showHistoryModal = (objectId: number) => {
    setHistoryModalVisible(true);
    setObjectId(objectId);
  };

  const columnsWidths = {
    ...versionsTableUtils.columnsWidths,
    name: "100px",
    alias: "100px",
    dataTypeId: "100px",
  };

  const getColumns = (): TableColumn<TableData>[] => [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: columnsWidths.id,
      hidden: true,
    },
    {
      title: "Наименование",
      dataIndex: "name",
      key: "name",
      width: columnsWidths.name,
      hidden: false,
    },
    {
      title: "Alias",
      dataIndex: "alias",
      key: "alias",
      width: columnsWidths.alias,
      hidden: false,
    },
    {
      title: "Тип данных",
      dataIndex: "dataTypeId",
      key: "dataTypeId",
      width: columnsWidths.dataTypeId,
      hidden: false,
      render: (dataTypeId: number) =>
        versionsTableUtils.getDictionaryItemById(typesCharacteristicsTypesDataDic, dataTypeId)
          ?.name,
    },

    {
      dataIndex: "actions",
      key: "actions",
      width: columnsWidths.actions,
      hidden: true,
    },

    {
      dataIndex: "buttons",
      key: "buttons",
      width: columnsWidths.buttons,
      className: "history-column history-column-end",
      style: { display: "flex", justifyContent: "end" },
      render: (value, record) => (
        <Row justify="end">
          <Button
            onClick={(e) => {
              e.stopPropagation();
              showHistoryModal(Number(record?.id));
            }}
            className="iconButton"
            type="text"
            htmlType="button"
            icon={<DotsIcon />}
          />
        </Row>
      ),
    },
  ];

  const [columns, setColumns] = useState<TableColumn<TableData>[]>(getColumns());

  // Обновление колонок
  useEffect(() => {
    setColumns(getColumns());
  }, [typesCharacteristicsTypesDataDic]);

  const tableData = useMemo((): TableData[] => {
    const data: TableData[] = typesCharacteristics.map(({ name, id, alias, dataTypeId }) => ({
      key: id,
      id,
      name,
      alias,
      dataTypeId,
    }));
    return data;
  }, [typesCharacteristics, typesCharacteristicsTypesDataDic]);

  const onFinish = () => {};

  return (
    <div className="types-characteristics-list-table">
      <Form form={form} onFinish={onFinish}>
        <ToggleableVersionsTable
          tableName="policies-list-table"
          columns={columns}
          setColumns={setColumns}
          tableData={tableData}
          childTableData={[]}
          isTableLoading={checkIsLoading(typesCharacteristicsLoading)}
          isChildTableLoading={false}
          onRow={(record) => ({
            onClick: () => {
              history.push(`/types-characteristics/${record.id}`);
            },
          })}
          isPageable={{
            current: typesCharacteristicsPagination.current + 1,
            total: typesCharacteristicsPagination.total,
            pageSize: 10,
            showSizeChanger: false,
            onChange: (page: number) => {
              handleTypesCharacteristicsListSearch({ page: page - 1 });
            },
          }}
          isVisibleEye={false}
        />
      </Form>

      <HistoryAndPropertyModal
        objectTypeSysname="char_type"
        objectId={objectId}
        handleHideModal={() => {
          setHistoryModalVisible(false);
        }}
        visibleModal={historyModalVisible}
        // hasAccessToEdit={hasAccess(MENU_ADMIN_OFFERING_POLICY_WRITE)}
      />
    </div>
  );
};
